import { gql } from "graphql-request";

export const SALES_EXPORT = gql`
  query SalesExport($input: ExportGenerateInput) {
    GenerateExport(input: $input)
  }
`;
